import * as types from '../mutation-types'
import api from '@/api/api'

const state = {
  detail: {
    BeginAt: '',
    EndAt: ''
  },
  faceList: [],
  photoList: [],
  totalNum: 0,
  hotTotalNum: 0,
  largePhotoList: [],
  hotPageIndex: 1,
  pageIndex: 1,
  interactionList: [],
  interactionDetail: {},
  currentUserInteractionList: []
}

const getters = {}

const mutations = {
  // 获取live详情信息
  [types.live.getLiveDetail](state, res) {
    state.detail = res
  },

  // 获取图片列表
  [types.live.getPhotoList](state, res) {
    state.loadState = true
    if (state.pageIndex == 1) {
      state.photoList = []
    }
    state.photoList = state.photoList.concat(res.Result)
    state.totalNum = res.Total
  },

  // 获取大图列表
  [types.live.getLargePhotoList](state, res) {
    state.hotLoadState = true
    if (state.hotPageIndex == 1) {
      state.largePhotoList = []
    }
    state.largePhotoList = state.largePhotoList.concat(res.Result)
    state.hotTotalNum = res.Total
  },

  // 更新页面序号
  [types.live.setPageIndex](state, res) {
    state.pageIndex = res.index
  },

  // 获取互动列表
  [types.live.getInteractionList](state, res) {
    state.interactionList = res
  },

  // 获取人脸识别内容
  [types.live.getFaceList](state, res) {
    state.faceList = res
  },

  // 获取互动详情
  [types.live.getInteractionDetail](state, res) {
    state.interactionDetail = res
  },

  // 获取某个用户的互动列表
  [types.live.getInteractionListByUserId](state, res) {
    state.currentUserInteractionList = res
  }
}

const actions = {
  // 获取face list
  getFaceList(context, data) {
    console.log('come in getFaceList action')
    return new Promise((resolve, reject) => {
      api.live
        .faceRecog(data.liveId, data.url)
        .then(res => {
          if (res) {
            context.commit(types.live.getFaceList, res.data)
            resolve()
          }
        })
        .catch(err => {
          reject(err)
        })
    })
  },

  // 获取live详情
  getLiveDetail(context, data) {
    return new Promise((resolve, reject) => {
      api.live.getLiveDetail(data.liveId, data.router, res => {
        if (res) {
          context.commit(types.live.getLiveDetail, res.data)
          resolve()
        } else {
          console.log('网络异常')
          reject()
        }
      })
    })
  },

  // 获取图片list
  getPhotoList(context, args) {
    api.live.getPhotoList(args, res => {
      if (res) {
        context.commit(types.live.getPhotoList, res.data)
      } else {
        console.log('网络异常')
      }
    })
  },

  // 获取大图list
  getLargePhotoList(context, args) {

    return new Promise((resolve, reject) => {
      api.live.getPhotoList(args, res => {

        if (res) {
          context.commit(types.live.getLargePhotoList, res.data)
          resolve()
        } else {
          console.log('网络异常')
          reject()
        }
      })
    })
  },

  /**
   * 查询互动列表+关联点赞、评论的信息
   * @param {*} context
   * @param {*} data
   */
  getInteractionList(context, data) {
    return new Promise((resolve, reject) => {
      // 保存互动信息列表
      let itList = []
      // 保存点赞列表
      let likeRes = {}
      // 保存评论列表
      let commentRes = {}
      // 查询列表
      api.live
        .getInteractionList(data.liveId, data.pageIndex, data.pageSize)
        .then(list => {
          itList = list.data
          // 返回的promise对象数组
          let promiseArr = []
          list.data.Result.map(item => {
            // 遍历互动列表 显示20条like列表信息
            promiseArr.push(api.live.getInteractionLikeList(item.Id, 1, 22))
          })
          return Promise.all(promiseArr)
        })
        .then(likeList => {
          likeRes = likeList
          // 查询评论列表
          let newPromiseArr = []
          itList.Result.map(item => {
            newPromiseArr.push(
              api.live.getInteractionCommentList(item.Id, 1, 10)
            )
          })

          return Promise.all(newPromiseArr)
        })
        .then(commentList => {
          commentRes = commentList
          itList.Result.map((interact, i) => {
            interact.isLiked = false
            // 存储点赞数据和评论数据
            interact.likeInfo = likeRes[i]
            interact.commentInfo = commentRes[i]

            // 存储是否点过赞
            api.live
              .checkLike(JSON.parse(window.localStorage.user).Id, interact.Id)
              .then(res => {
                // console.log(res)
                interact.isLiked = res
              })
          })
          // 提交重构对象 console.log('===========', itList)
          context.commit(types.live.getInteractionList, itList)
          resolve()
        })
    })
  },

  /**
   * 查询某个用户互动列表+关联点赞、评论的信息
   * @param {*} context
   * @param {*} data
   */
  getUserInteractionList(context, data) {
    return new Promise((resolve, reject) => {
      // 保存互动信息列表
      let itList = []
      // 保存点赞列表
      let likeRes = {}
      // 保存评论列表
      let commentRes = {}
      // 查询列表
      api.live
        .getInteractionList(
          data.liveId,
          data.pageIndex,
          data.pageSize,
          data.userId
        )
        .then(list => {
          itList = list.data
          // 返回的promise对象数组
          let promiseArr = []
          list.data.Result.map(item => {
            // 遍历互动列表 显示20条like列表信息
            promiseArr.push(api.live.getInteractionLikeList(item.Id, 1, 22))
          })
          return Promise.all(promiseArr)
        })
        .then(likeList => {
          likeRes = likeList
          // 查询评论列表
          let newPromiseArr = []
          itList.Result.map(item => {
            newPromiseArr.push(
              api.live.getInteractionCommentList(item.Id, 1, 10)
            )
          })

          return Promise.all(newPromiseArr)
        })
        .then(commentList => {
          commentRes = commentList
          itList.Result.map((interact, i) => {
            interact.isLiked = false
            // 存储点赞数据和评论数据
            interact.likeInfo = likeRes[i]
            interact.commentInfo = commentRes[i]

            // 存储是否点过赞
            likeRes[i].data.Result.map(item => {
              // console.log(JSON.parse(window.localStorage.user).Id + ' = ' + item.Id)
              if (item.Id == JSON.parse(window.localStorage.user).Id) {
                // 更新点赞状态
                interact.isLiked = true
              }
            })
          })
          // 提交重构对象 console.log('===========', itList)
          context.commit(types.live.getInteractionListByUserId, itList)
          resolve()
        })
    })
  },

  /**
   * 加载评论数据

  loadInteractionComment(context, data) {
    return new Promise((resolve, reject) => {
      api
        .live
        .getInteractionCommentList(data.interactId, data.pageIndex, data.pageSize)
        .then(res => {
          if (res.data.Result.length > 0) {
            resolve(res.data.Result)
          } else {
            console.log('没有数据了')
          }
        })
        .catch(err => {
          console.log(err)
        })
    })
  },
  */

  /**
   * 获取互动详情
   * @param {*} context
   * @param {*} data
   */
  getInteractionDetail(context, data) {
    return new Promise((resolve, reject) => {
      api.live.getInteractionDetail(data.interactionId, res => {
        if (res) {
          context.commit(types.live.getInteractionDetail, res.data)
          resolve(res.data)
        } else {
          console.log('网络异常')
          reject()
        }
      })
    })
  },

  /**
   * 互动发布功能
   * @param {*} context
   * @param {*} data
   */
  interactionPublish(context, data) {
    return new Promise((resolve, reject) => {
      api.live.publishInteraction(
        data.title,
        data.picture,
        data.activityId,
        res => {
          if (res) {
            // context.commit(types.live.publish)
            resolve(res)
          } else {
            console.log('网络异常')
            reject()
          }
        }
      )
    })
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/live.js